import Layout from '@/layout'
// import ParentView from '@/components/ParentView'

const asyncDetectionTaskRoutes =
{
  path: '/lab/DetectionTask',
  component: Layout,
  redirect: 'noredirect',
  name: '样品检测管理',
  funcPerms: 'lab:test',
  meta: {
    title: '样品检测管理',
    icon: 'test',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'sampleTestingManagement/personnelSettings',
      component: () => import('@/views/lab/sampleTestingManagement/personnelSettings/index'),
      funcPerms: 'lab:test:projectAllocation',
      name: 'personnelSettings',
      meta: {
        title: '检测项目人员设置',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleTestingManagement/sampleAcceptance',
      component: () => import('@/views/lab/sampleTestingManagement/sampleAcceptance/index'),
      funcPerms: 'lab:test:sampleAcceptance',
      name: 'sampleAcceptance',
      meta: {
        title: '验样领样',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleTestingManagement/sampleAcceptance/view',
      component: () => import('@/views/lab/sampleTestingManagement/sampleAcceptance/view'),
      funcPerms: 'lab:test:sampleAcceptance:view',
      name: 'sampleAcceptanceView',
      hidden: true,
      meta: {
        title: '查看验样领样',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    // 任务分配一级菜单
    {
      path: 'sampleTestingManagement/taskDispense',
      component: () => import('@/views/lab/sampleTestingManagement/taskDispense/index'),
      funcPerms: 'lab:test:taskDispense',
      name: 'taskDispense',
      meta: {
        title: '任务分配',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleTestingManagement/taskDispense/view',
      component: () => import('@/views/lab/sampleTestingManagement/taskDispense/view'),
      funcPerms: 'lab:test:taskDispense:view',
      name: 'taskDispenseView',
      hidden: true,
      meta: {
        title: '查看任务分配',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    // 检测任务一级菜单
    {
      path: 'sampleTestingManagement/sampleTask',
      component: () => import('@/views/lab/sampleTestingManagement/sampleTask/index'),
      funcPerms: 'lab:test:testTask',
      name: 'sampleTask',
      meta: {
        title: '检测任务',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    // 检测校核一级菜单
    {
      path: 'ProjectAllocationindex',
      component: () => import('@/views/lab/ProjectAllocation/index'),
      funcPerms: 'lab:test:projectAllocation',
      name: 'ProjectAllocationindex',
      meta: {
        title: '检测校核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'ProjectAllocationindex/examine',
      component: () => import('@/views/lab/ProjectAllocation/examine'),
      funcPerms: 'lab:test:projectAllocation:verify',
      name: 'examine',
      hidden: true,
      meta: {
        title: '校核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    // 检测审核一级菜单
    {
      path: 'sampleTestingManagement/sampleAudit',
      component: () => import('@/views/lab/sampleTestingManagement/sampleAudit/index'),
      funcPerms: 'lab:test:testAudit',
      name: 'sampleAudit',
      meta: {
        title: '检测审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'Audit',
      component: () => import('@/views/lab/sampleTestingManagement/sampleAudit/Audit'),
      funcPerms: 'lab:test:testAudit:audit',
      name: 'Audit',
      hidden: true,
      meta: {
        title: '审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'allocation',
      component: () => import('@/views/lab/ProjectAllocation/allocation'),
      funcPerms: 'lab:test:testAudit:task',
      name: 'allocation',
      hidden: true,
      meta: {
        title: '分配任务', // 检测审核中的按钮
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'add',
      component: () => import('@/views/lab/DetectionTask/add'),
      funcPerms: 'lab:test:testTask:write',
      name: 'DetectionTaskindexAdd',
      hidden: true,
      meta: {
        title: '检测结果录入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'view',
      component: () => import('@/views/lab/DetectionTask/add'),
      funcPerms: 'lab:test:testTask:view',
      name: 'DetectionTaskindexview',
      hidden: true,
      meta: {
        title: '查看检测结果',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/sampleTestingManagement/originalRecordForm',
    //   component: () => import('@/views/sampleTestingManagement/originalRecordForm/index'),
    //   funcPerms: 'lab:test:projectAllocation',
    //   name: 'originalRecordForm',
    //   meta: {
    //     title: '原始记录表查看',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/sampleTestingManagement/sampleCheck',
    //   component: () => import('@/views/sampleTestingManagement/sampleCheck/index'),
    //   funcPerms: 'lab:test:projectAllocation',
    //   name: 'sampleCheck',
    //   meta: {
    //     title: '检测校核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'sampleTestingManagement/reportIssuance',
      component: () => import('@/views/lab/sampleTestingManagement/reportIssuance/index'),
      funcPerms: 'lab:test:reportIssuance',
      name: 'reportIssuance',
      meta: {
        title: '报告签发',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleTestingManagement/reportIssuance/view',
      component: () => import('@/views/lab/sampleTestingManagement/reportIssuance/view'),
      funcPerms: 'lab:test:reportIssuance:view',
      name: 'reportIssuanceView',
      hidden: true,
      meta: {
        title: '报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'DetectionTask/Record',
      component: () => import('@/views/lab/DetectionTask/Record'),
      funcPerms: 'lab:test:testTask:write',
      name: 'DetectionTaskRecord',
      hidden: true,
      meta: {
        title: '配置原始记录表',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }

  ]
}

export default asyncDetectionTaskRoutes
